import React from 'react';
import PropTypes from 'prop-types';
import './styles.css';

const MapEmptyState = ({ t }) => {
  return (
    <div className="map-empty-state">
      <div className="map-empty-illustration">
        <div className="map-empty-pin">
          <span className="material-symbols-outlined">location_on</span>
        </div>
        <div className="map-empty-ripple map-empty-ripple-1" />
        <div className="map-empty-ripple map-empty-ripple-2" />
        <div className="map-empty-ripple map-empty-ripple-3" />
      </div>
      <h3 className="map-empty-title">
        {t('mapView:emptyStateTitle')}
      </h3>
      <p className="map-empty-description">
        {t('mapView:emptyStateDescription')}
      </p>
    </div>
  );
};

MapEmptyState.propTypes = {
  t: PropTypes.func.isRequired,
};

export default MapEmptyState;
